//Library Imports
import styled from "styled-components";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

//Local Imports
import Email from "../../../assets/img/icons/ArticlePopover/Email.svg";
import Facebook from "../../../assets/img/icons/ArticlePopover/facebook.svg";
import Linkedin from "../../../assets/img/icons/ArticlePopover/linkedin.svg";
import Twitter from "../../../assets/img/icons/ArticlePopover/twitter.svg";
import Frame11 from "../../../assets/img/icons/ArticlePopover/Frame11.svg";
import PopoverWithoutOptions from "./PopoverWithoutOptions";
import { FACEBOOK_SHARE_PREFIX, LINKEDIN_URL_PREFIX, TWITTER_SHARE_URL_PREFIX } from "../../../constants/index";

const shareEmail = (props) => {
  window.location =
    "mailto:?subject=" +
    escape(props?.title) +
    "&body=" +
    escape(props.article_link ? props.article_link : props.link);
};

const shareOnFacebook = (props) => {
  var share_window_url =
    FACEBOOK_SHARE_PREFIX + encodeURIComponent(props.article_link ? props.article_link : props.link);
  var pop = window.open(share_window_url, "Image", "width=1024, height=640,scrollbars=yes");
  pop.focus();
};

const shareOnLinkedin = (props) => {
  var share_window_url =
    LINKEDIN_URL_PREFIX + encodeURIComponent(props.article_link ? props.article_link : props.link);
  var pop = window.open(share_window_url, "Image", "width=1024, height=640,scrollbars=yes");
  pop.focus();
};

const shareOnTwitter = (props) => {
  var share_window_url =
    TWITTER_SHARE_URL_PREFIX + encodeURIComponent(props.article_link ? props.article_link : props.link);
  var pop = window.open(share_window_url, "Image", "width=1024, height=640,scrollbars=yes");
  pop.focus();
};

const shareOnBuffer = (props) => {
  const url =
    "https://buffer.com/add?id=" +
    ((65536 * (1 + Math.random())) | 0).toString(16).substring(1) +
    ((65536 * (1 + Math.random())) | 0).toString(16).substring(1) +
    ((65536 * (1 + Math.random())) | 0).toString(16).substring(1) +
    ((65536 * (1 + Math.random())) | 0).toString(16).substring(1) +
    "&url=" +
    encodeURIComponent(props.article_link ? props.article_link : props.link) +
    "&text=" +
    encodeURIComponent(props.title) +
    "&source=button&placement=button&utm_source=" +
    encodeURIComponent(window.location.href) +
    "&utm_medium=buffer_button&utm_campaign=buffer";
  window.open(url, "_blank");
};

/* content for popover */
const popupTitle = (props) => {
  return (
    <div className="popover-wrapper-style">
      <h4 className="padding-bottom-xs title-text">QuickShare to:</h4>
      <div className="d-flex links-container" style={{ justifyContent: "space-between" }}>
        <span>
          <img src={Email} alt="Email" onClick={(e) => shareEmail(props)} />
        </span>
        <span>
          <img src={Facebook} alt="Facebook" onClick={(e) => shareOnFacebook(props)} />
        </span>
        <span>
          <img src={Linkedin} alt="Linkedin" onClick={(e) => shareOnLinkedin(props)} />
        </span>
        <span>
          <img src={Twitter} alt="Twitter" onClick={(e) => shareOnTwitter(props)} />
        </span>
        <span>
          <img src={Frame11} alt="Buffer" onClick={(e) => shareOnBuffer(props)} />
        </span>
      </div>
    </div>
  );
};

const BlogMenuStylingGreen = styled.div`
  ul li {
    font-family: "roboto_regular", sans-serif;
    font-size: 14px;
    color: #27ce0a;
    padding-top: 5px;
    padding-bottom: 5px;
  }
  .opc-5 {
    opacity: 0.5;
  }
`;

const recipeintTitle = () => {
  return (
    <BlogMenuStylingGreen>
      <div className="BlogItemDropdown">
        <ul>
          <li className="d-flex align-items-center">
            <strong>Edit List</strong>
          </li>
        </ul>
      </div>
    </BlogMenuStylingGreen>
  );
};

function ShareMenuPopup(props) {
  const [visible, setVisible] = useState(false);
  const { data, inArticlePreview, inEngagementTab, scrollCheck, engagementIsActive } = props;

  const detailProfileScrollCheck = useSelector((state) => state.uiReducer.detailProfileScrollCheck);
  const articleDivScrollCheck = useSelector((state) => state.uiReducer.articleDivScrollCheck);

  const hide = () => {
    setVisible(false);
  };

  useEffect(() => {
    if (engagementIsActive) hide();
  }, [detailProfileScrollCheck]);

  useEffect(() => {
    hide();
  }, [articleDivScrollCheck]);

  const handleVisibleChange = (visible) => {
    setVisible(visible);
  };

  useEffect(() => {
    if (visible) hide();
  }, [scrollCheck]);

  return (
    <PopoverWithoutOptions
      overlayInnerStyle={{ borderRadius: 10 }}
      overlayClassName={
        inArticlePreview
          ? "Popover-share Popover-share-sidebar"
          : inEngagementTab
          ? { zIndex: 21 }
          : "Popover-share"
      }
      placement={inArticlePreview ? "bottom" : "leftTop"}
      visible={visible}
      trigger="click"
      content={props?.data?.recipientMenu ? recipeintTitle : popupTitle(data)}
      onVisibleChange={handleVisibleChange}
    >
      {props.children}
    </PopoverWithoutOptions>
  );
}

export default ShareMenuPopup;
